// From https://bitbucket.org/atlassian/atlaskit-mk-2/raw/4ad0e56649c3e6c973e226b7efaeb28cb240ccb0/packages/core/select/src/data/countries.js
const countries = [
	{ code: 'AC', label: 'Ascensão' },
	{ code: 'AD', label: 'Andorra' },
	{ code: 'AE', label: 'Emirados Árabes Unidos' },
	{ code: 'AF', label: 'Afeganistão' },
	{ code: 'AG', label: 'Antígua e Barbuda' },
	{ code: 'AI', label: 'Anguila' },
	{ code: 'AL', label: 'Albânia' },
	{ code: 'AM', label: 'Arménia' },
	{ code: 'AN', label: 'Antilhas Neerlandesas' },
	{ code: 'AO', label: 'Angola' },
	{ code: 'AQ', label: 'Antártida' },
	{ code: 'AR', label: 'Argentina' },
	{ code: 'AS', label: 'Samoa Americana' },
	{ code: 'AT', label: 'Áustria' },
	{ code: 'AU', label: 'Austrália' },
	{ code: 'AW', label: 'Aruba' },
	{ code: 'AZ', label: 'Azerbaijão' },
	{ code: 'BA', label: 'Bósnia e Herzegovina' },
	{ code: 'BB', label: 'Barbados' },
	{ code: 'BD', label: 'Bangladexe' },
	{ code: 'BE', label: 'Bélgica' },
	{ code: 'BF', label: 'Burquina Faso' },
	{ code: 'BG', label: 'Bulgária' },
	{ code: 'BH', label: 'Barém' },
	{ code: 'BI', label: 'Burundi' },
	{ code: 'BJ', label: 'Benim' },
	{ code: 'BM', label: 'Bermudas' },
	{ code: 'BN', label: 'Brunei Darussalam' },
	{ code: 'BO', label: 'Bolívia' },
	{ code: 'BR', label: 'Brasil' },
	{ code: 'BS', label: 'Bahamas' },
	{ code: 'BT', label: 'Butão' },
	{ code: 'BV', label: 'Ilha Bouvet' },
	{ code: 'BW', label: 'Botsuana' },
	{ code: 'BY', label: 'Bielorrússia' },
	{ code: 'BZ', label: 'Belize' },
	{ code: 'CA', label: 'Canadá' },
	{ code: 'CC', label: 'Ilhas Cocos' },
	{ code: 'CD', label: 'República Democrática do Congo' },
	{ code: 'CF', label: 'República Centro-Africana' },
	{ code: 'CG', label: 'República do Congo' },
	{ code: 'CH', label: 'Suíça' },
	{ code: 'CI', label: 'Costa do Marfim' },
	{ code: 'CK', label: 'Ilhas Cook' },
	{ code: 'CL', label: 'Chile' },
	{ code: 'CM', label: 'Camarões' },
	{ code: 'CN', label: 'República Popular da China' },
	{ code: 'CO', label: 'Colômbia' },
	{ code: 'CR', label: 'Costa Rica' },
	{ code: 'CU', label: 'Cuba' },
	{ code: 'CV', label: 'Cabo Verde' },
	{ code: 'CX', label: 'Ilha Natal' },
	{ code: 'CY', label: 'Chipre' },
	{ code: 'CZ', label: 'Chéquia' },
	{ code: 'DE', label: 'Alemanha (Deutschland)' },
	{ code: 'DJ', label: 'Djibuti' },
	{ code: 'DK', label: 'Dinamarca' },
	{ code: 'DM', label: 'Dominica' },
	{ code: 'DO', label: 'República Dominicana' },
	{ code: 'DZ', label: 'Argélia' },
	{ code: 'EC', label: 'Equador' },
	{ code: 'EE', label: 'Estónia' },
	{ code: 'EG', label: 'Egito' },
	{ code: 'ER', label: 'Eritreia' },
	{ code: 'ES', label: 'Espanha' },
	{ code: 'ET', label: 'Etiópia' },
	{ code: 'EU', label: 'Europa' },
	{ code: 'FI', label: 'Finlândia' },
	{ code: 'FJ', label: 'Fiji' },
	{ code: 'FK', label: 'Malvinas (Falkland Islands)' },
	{ code: 'FM', label: 'Estados Federados da Micronésia' },
	{ code: 'FO', label: 'Ilhas Feroé' },
	{ code: 'FR', label: 'França' },
	{ code: 'GA', label: 'Gabão' },
	{ code: 'GB', label: 'Grã Bretanha' },
	{ code: 'GD', label: 'Granada' },
	{ code: 'GE', label: 'Geórgia' },
	{ code: 'GF', label: 'Guiana Francesa' },
	{ code: 'GG', label: 'Guernsey' },
	{ code: 'GH', label: 'Gana' },
	{ code: 'GI', label: 'Gibraltar' },
	{ code: 'GL', label: 'Groenlândia' },
	{ code: 'GM', label: 'Gâmbia' },
	{ code: 'GN', label: 'Guiné' },
	{ code: 'GP', label: 'Guadalupe' },
	{ code: 'GQ', label: 'Guiné Equatorial' },
	{ code: 'GR', label: 'Grécia' },
	{ code: 'GS', label: 'Ilhas Geórgia do Sul e Sanduíche do Sul' },
	{ code: 'GT', label: 'Guatemala' },
	{ code: 'GU', label: 'Guam' },
	{ code: 'GW', label: 'Guiné-Bissau' },
	{ code: 'GY', label: 'Guiana' },
	{ code: 'HK', label: 'Hong Kong' },
	{ code: 'HM', label: 'Ilha Heard e Ilhas McDonald' },
	{ code: 'HN', label: 'Honduras' },
	{ code: 'HR', label: 'Croácia' },
	{ code: 'HT', label: 'Haiti' },
	{ code: 'HU', label: 'Hungria' },
	{ code: 'ID', label: 'Indonésia' },
	{ code: 'IE', label: 'Irlanda' },
	{ code: 'IL', label: 'Israel' },
	{ code: 'IM', label: 'Ilha de Man' },
	{ code: 'IN', label: 'Índia' },
	{ code: 'IO', label: 'Território Britânico do Oceano Índico' },
	{ code: 'IQ', label: 'Iraque' },
	{ code: 'IR', label: 'Irão' },
	{ code: 'IS', label: 'Islândia' },
	{ code: 'IT', label: 'Itália' },
	{ code: 'JE', label: 'Jersey' },
	{ code: 'JM', label: 'Jamaica' },
	{ code: 'JO', label: 'Jordânia' },
	{ code: 'JP', label: 'Japão' },
	{ code: 'KE', label: 'Quénia' },
	{ code: 'KG', label: 'Quirguistão' },
	{ code: 'KH', label: 'Camboja' },
	{ code: 'KI', label: 'Quiribati' },
	{ code: 'KM', label: 'Comores' },
	{ code: 'KN', label: 'São Cristóvão e Neves' },
	{ code: 'KP', label: 'Coreia do Norte' },
	{ code: 'KR', label: 'Coreia do Sul' },
	{ code: 'KW', label: 'Kuwait' },
	{ code: 'KY', label: 'Ilhas Caimã' },
	{ code: 'KZ', label: 'Cazaquistão' },
	{ code: 'LA', label: 'Laos' },
	{ code: 'LB', label: 'Líbano' },
	{ code: 'LC', label: 'Santa Lúcia' },
	{ code: 'LI', label: 'Liechtenstein' },
	{ code: 'LK', label: 'Seri Lanca' },
	{ code: 'LR', label: 'Libéria' },
	{ code: 'LS', label: 'Lesoto' },
	{ code: 'LT', label: 'Lituânia' },
	{ code: 'LU', label: 'Luxemburgo' },
	{ code: 'LV', label: 'Letónia' },
	{ code: 'LY', label: 'Líbia' },
	{ code: 'MA', label: 'Marrocos' },
	{ code: 'MC', label: 'Mónaco' },
	{ code: 'MD', label: 'Moldávia' },
	{ code: 'ME', label: 'Montenegro' },
	{ code: 'MG', label: 'Madagáscar' },
	{ code: 'MH', label: 'Ilhas Marshall' },
	{ code: 'MK', label: 'Antiga República Jugoslava da Macedónia' },
	{ code: 'ML', label: 'Mali' },
	{ code: 'MM', label: 'Mianmar' },
	{ code: 'MN', label: 'Mongólia' },
	{ code: 'MO', label: 'Macau' },
	{ code: 'MP', label: 'Marianas Setentrionais' },
	{ code: 'MQ', label: 'Martinica' },
	{ code: 'MR', label: 'Mauritânia' },
	{ code: 'MS', label: 'Monserrate' },
	{ code: 'MT', label: 'Malta' },
	{ code: 'MU', label: 'Maurício' },
	{ code: 'MV', label: 'Maldivas' },
	{ code: 'MW', label: 'Maláui' },
	{ code: 'MX', label: 'México' },
	{ code: 'MY', label: 'Malásia' },
	{ code: 'MZ', label: 'Moçambique' },
	{ code: 'NA', label: 'Namíbia' },
	{ code: 'NC', label: 'Nova Caledónia' },
	{ code: 'NE', label: 'Níger' },
	{ code: 'NF', label: 'Ilha Norfolque' },
	{ code: 'NG', label: 'Nigéria' },
	{ code: 'NI', label: 'Nicarágua' },
	{ code: 'NL', label: 'Países Baixos' },
	{ code: 'NO', label: 'Noruega' },
	{ code: 'NP', label: 'Nepal' },
	{ code: 'NR', label: 'Nauru' },
	{ code: 'NU', label: 'Niue' },
	{ code: 'NZ', label: 'Nova Zelândia' },
	{ code: 'OM', label: 'Omã' },
	{ code: 'PA', label: 'Panamá' },
	{ code: 'PE', label: 'Peru' },
	{ code: 'PF', label: 'Polinésia Francesa' },
	{ code: 'PG', label: 'Papua-Nova Guiné' },
	{ code: 'PH', label: 'Filipinas' },
	{ code: 'PK', label: 'Paquistão' },
	{ code: 'PL', label: 'Polónia' },
	{ code: 'PM', label: 'São Pedro e Miquelão' },
	{ code: 'PN', label: 'Ilhas Pitcairn' },
	{ code: 'PR', label: 'Porto Rico' },
	{ code: 'PS', label: 'Territórios palestinianos (i.e., Cisjordânia e Faixa de Gaza)' },
	{ code: 'PT', label: 'Portugal' },
	{ code: 'PW', label: 'Palau' },
	{ code: 'PY', label: 'Paraguai' },
	{ code: 'QA', label: 'Qatar' },
	{ code: 'RE', label: 'Reunião' },
	{ code: 'RO', label: 'Roménia' },
	{ code: 'RU', label: 'Rússia' },
	{ code: 'RW', label: 'Ruanda' },
	{ code: 'SA', label: 'Arábia Saudita' },
	{ code: 'SB', label: 'Ilhas Salomão' },
	{ code: 'SC', label: 'Seicheles' },
	{ code: 'SCOT', label: 'Escócia' },
	{ code: 'SD', label: 'Sudão' },
	{ code: 'SE', label: 'Suécia' },
	{ code: 'SG', label: 'Singapura' },
	{ code: 'SH', label: 'Santa Helena' },
	{ code: 'SI', label: 'Eslovénia' },
	{ code: 'SJ', label: 'Ilhas Esvalbarde e Jan Mayen' },
	{ code: 'SK', label: 'Eslováquia' },
	{ code: 'SL', label: 'Serra Leoa' },
	{ code: 'SM', label: 'San Marino' },
	{ code: 'SN', label: 'Senegal' },
	{ code: 'SO', label: 'Somália' },
	{ code: 'SR', label: 'Suriname' },
	{ code: 'SS', label: 'Sudão do Sul' },
	{ code: 'ST', label: 'São Tomé e Príncipe' },
	{ code: 'SU', label: 'antiga União Soviética' },
	{ code: 'SV', label: 'El Salvador' },
	{ code: 'SY', label: 'Síria' },
	{ code: 'SZ', label: 'Essuatíni (antes, Suazilândia)' },
	{ code: 'TC', label: 'Ilhas Turcas e Caicos' },
	{ code: 'TD', label: 'Chade' },
	{ code: 'TF', label: 'Terras Austrais e Antárticas Francesas' },
	{ code: 'TG', label: 'Togo' },
	{ code: 'TH', label: 'Tailândia' },
	{ code: 'TJ', label: 'Tajiquistão' },
	{ code: 'TK', label: 'Toquelau' },
	{ code: 'TL', label: 'Timor-Leste' },
	{ code: 'TM', label: 'Turcomenistão' },
	{ code: 'TN', label: 'Tunísia' },
	{ code: 'TO', label: 'Tonga' },
	{ code: 'TR', label: 'Turquia' },
	{ code: 'TT', label: 'Trindade e Tobago' },
	{ code: 'TV', label: 'Tuvalu' },
	{ code: 'TW', label: 'Taiwan' },
	{ code: 'TZ', label: 'Tanzânia' },
	{ code: 'UA', label: 'Ucrânia' },
	{ code: 'UG', label: 'Uganda' },
	{ code: 'UK', label: 'Reino Unido' },
	{ code: 'UM', label: 'Ilhas Menores Distantes dos Estados Unidos' },
	{ code: 'US', label: 'Estados Unidos' },
	{ code: 'UY', label: 'Uruguai' },
	{ code: 'UZ', label: 'Uzbequistão' },
	{ code: 'VA', label: 'Vaticano' },
	{ code: 'VC', label: 'São Vicente e Granadinas' },
	{ code: 'VE', label: 'Venezuela' },
	{ code: 'VG', label: 'Ilhas Virgens Britânicas' },
	{ code: 'VI', label: 'Ilhas Virgens Americanas' },
	{ code: 'VN', label: 'Vietnã' },
	{ code: 'VU', label: 'Vanuatu' },
	{ code: 'WF', label: 'Wallis e Futuna' },
	{ code: 'WS', label: 'Samoa (antes, Samoa Ocidental)' },
	{ code: 'YE', label: 'Iémen' },
	{ code: 'YT', label: 'Maiote' },
	{ code: 'YU', label: 'Jugoslávia' },
	{ code: 'ZA', label: 'África do Sul' },
	{ code: 'ZM', label: 'Zâmbia' },
	{ code: 'ZW', label: 'Zimbábue' },
];

export default countries;
